import { useTranslation } from "react-i18next";

import type { OneValueMeasurement } from "~/api/lastMeasurements";
import { HeartRateVariability } from "~/icons";
import { formatBackendDate } from "~/utils";
import { HealthDetails } from "..";

interface HeartRateVariabilityProps {
  measurement: OneValueMeasurement | null;
}

export const HeartRateVariabilityCard = ({
  measurement,
}: HeartRateVariabilityProps) => {
  const { t } = useTranslation();

  const val = measurement ? measurement.value.toString() : t("health.no_data");

  return (
    <HealthDetails.Card>
      <HealthDetails.CardHeader>
        <HeartRateVariability className="text-primary-40 dark:text-primary-80" />
        <HealthDetails.CardTitle>
          {t("health.heart_rate_variability")}
        </HealthDetails.CardTitle>
      </HealthDetails.CardHeader>
      <HealthDetails.CardBody>
        <HealthDetails.CardResult>{val}</HealthDetails.CardResult>
        <HealthDetails.CardDetails>
          <HealthDetails.CardUnit>
            {t("health.milliseconds")}
          </HealthDetails.CardUnit>
          {measurement && (
            <HealthDetails.CardDate>
              {formatBackendDate(measurement.date)}
            </HealthDetails.CardDate>
          )}
        </HealthDetails.CardDetails>
      </HealthDetails.CardBody>
    </HealthDetails.Card>
  );
};
